import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIDatePicker, { DatePickerProps } from "components/datepicker";
import UISelect from 'components/selectbox/UISelect';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import BooleanUtil from "utils/BooleanUtil";
import StringUtil from "utils/StringUtil";
import UIUtils from "utils/UIUtils";

import codeDataStore from "common/codedata/store/CodeDataStore";
function ContentsContainer() {


	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20)
	const [codeValueId,setCodeValueId] = useState('')  
	const [codeGroupId,setCodeGroupId] = useState('')

	const [codeGroup,setCodeGroup] = useState('')
	const [codeGroupNm,setCodeGroupNm] = useState('')
	const [codeGroupUseYnNm,setCodeGroupUseYnNm] = useState('')
	const [codeGroupDc,setCodeGroupDc] = useState('')
	const [codeValueDc,setCodeValueDc] = useState('')

	
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();

	/**ibsheet 세팅  */
    //초기 데이터 설정

	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 0,
				//"PageLength": 20,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0"
			},
			//틀고정 좌측 컬럼 설정
			"LeftCols": [
			{"Header": "No","Name": "SEQ","Width": "90"}
			],
			// "LeftCols": [
			// 	{"Header": ["No","No"],"Name": "SEQ","Type": "Int","Width": 40,"ColMerge": 0}
			//   ],
			"Cols": [
			{"Header": "No","Type": "Int", "Name": "","Align": "Center","RelWidth": 1},
			{"Header": "코드 값" ,"Type": "Text","Name": "CODE_VALUE","RelWidth": 1,"Align": "Center","CanEdit": "0"},
			{"Header": "코드 값 이름","Type": "Text","Name": "CODE_VALUE_NM","RelWidth": 2,"Align": "Left","CanEdit": "0"},
			{"Header": "코드 값 설명","Type": "Text","Name": "CODE_VALUE_DC","RelWidth": 2,"Align": "Left","CanEdit": "0"},
			{"Header": "코드 값 사용여부","Type": "Enum","Name": "CODE_VALUE_USE_YN","RelWidth": 0.5,"Align": "Center","CanEdit": 0,"Enum": "|사용|미사용","EnumKeys": "|1|0"},
			]
				 
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				//초기 데이터 로딩
				initCall(receivedData.vCODE_GROUP_ID);
			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
		},
		//조회 데이터
		'data':[]
	}
	
	//====== 그리드 공통 부  END
	
	
    //검색 
    async function initCall(codeGroupId) {
		let param = {
			"CODE_GROUP_ID":codeGroupId
		};
		

		const response:any = await CommonUtil.execute({
		 	url:'adm_6411_detail',
		 	data: param
		})
       
		//전체데이터 
		let result = response.LIST;
		if(result.length > 0){
			setCodeGroup(result[0].CODE_GROUP);
			setCodeGroupId(result[0].CODE_GROUP_ID);
			setCodeGroupNm(result[0].CODE_GROUP_NM);
			setCodeGroupDc(result[0].CODE_GROUP_DC);
			setCodeGroupUseYnNm(result[0].CODE_GROUP_USE_YN_NM);
		
			//console.log(JSON.stringify(result));
			// 시트에 데이터를 넣습니다.
			ib.data = result;
			// @ts-ignore	
			sheet.loadSearchData(result);  //data 로딩 처리 
			// @ts-ignore	
			//sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		}
		
   
    }//검색

	//목록으로 
	const goList = (e) =>{
		history.push({
			pathname: './adm6410',  
			state: { data: receivedData }
		});
	}

	//코드 삭제 
	async function codeDelete() {

		let param = {
			"CODE_GROUP_ID": codeGroupId
		};

		if(await UIUtils.confirm('삭제하시겠습니까?')){
			const response:any = await CommonUtil.execute({
				url:'adm_6411_codeDelete',
				data: param
			})


			if (!response.COMMON_HEAD.ERROR) {
				await UIUtils.alert('삭제 되었습니다.');

				// 다른 페이지로 이동하면서 데이터 전달
				history.push({
					pathname: './adm6410',
					state: { data: receivedData }
				});		
			}
		}  
	}

	//수정 
	const codeUpdate = function (){
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
		pathname: './adm6412',
		state: { data: receivedData }
		});
	}

	
   // init 
	React.useEffect(() => {
		//넘어온 파라미터 바인딩   
		 if(receivedData != undefined){
			let codeGroupId = StringUtil.defaultString(receivedData.vCODE_GROUP_ID);
			setCodeGroupId(codeGroupId);
			localStorage.setItem("codeGroupId", codeGroupId);
		
			//ib시트 생성
			ib.create();

			//initCall(codeGroupId);
		}
		
        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);		  
		 
        }
    },[])
	
	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">시스템관리</a></li>
						<li className=""><a href="">코드관리</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">코드 상세</h1>
						<form className="fo fo-col3" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">코드그룹</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={codeGroup} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">코드그룹 이름</p>
									<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={codeGroupNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사용여부</p>
									<div className="fo-value">
									<UIInput className={'tf tf-md w100p ta-center'} value={codeGroupUseYnNm=='1'?'사용':'미사용'} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-m-1-4">
									<p className="fo-key">코드그룹 설명</p>
									<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={codeGroupDc} placeholder={''} readOnly={true} />
									</div>
								</div>													
								<div className="fo-item fo-m-1-4">
									<p className="fo-key">코드값 목록</p>
									<div className="fo-value">
										<div id='sheetDiv' className='ibsheet'>[D] IBSHEET 영역</div>
									</div>
								</div>											

							</div>
						</form>
						<div className="hz-root hz-right hz-gap5">
							<Button color="gray-o" size="sm" onClick={codeDelete}>삭제</Button>
							<Button color="pri-o" size="sm" onClick={codeUpdate}>수정</Button>
							<Button color="gray-o" size="sm" onClick={goList}>목록</Button>
						</div>
					</main>

				</div>
		</PageContainer>
	);
}
export default ContentsContainer;